import { Button } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useLoaderData, useLocation, useNavigate } from "react-router-dom";

import { useQueryParams } from "../../../../../../hooks/useQueryParams";
import CaseListFilter from "../../../../../modules/CaseList/Filters";
import CaseListChips from "../../../../../modules/CaseList/Filters/Chips";
import FiltersList from "../../../../../modules/CaseList/Filters/FiltersList";
import CaseListHeader from "../../../../../modules/CaseList/Filters/Header";
import CaseListSearch from "../../../../../modules/CaseList/Filters/Search";
import { useCaseListFilters } from "../../../../../modules/CaseList/hooks/useCaseListFilters";
import { FilterListConfig } from "../../../../../modules/CaseList/utils/FilterListConfig";
import Svg, { SvgEnum } from "../../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../../ui library/HNSColors";

import CaseTable from "./components/Table";
import ItemCounter from "./components/TotalCount";

export default function CaseListList({ customBaseDetailPath = "", customBaseDetailSegment = "" }) {
  const navigate = useNavigate();
  const { cases, count, userStats } = useLoaderData();
  const { filterState, activeFilters } = useCaseListFilters(FilterListConfig);
  const { filters, updateFilter } = useQueryParams();
  const [filteredCases, setFilteredCases] = useState(cases);
  const location = useLocation();
  const scrollRef = useRef(null);
  const storageKey = customBaseDetailPath === "/client-detail/" ? "Dashboard" : "FinanceDashboard";

  useEffect(() => {
    updateFilter("limit", 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setFilteredCases(cases);
    if (scrollRef.current) {
      scrollToTop();
    }
  }, [cases]);

  useEffect(() => {
    const urlString = location.pathname + location.search;
    localStorage.setItem(storageKey, urlString);
  }, [location.pathname, location.search, storageKey]);

  const scrollToTop = () => {
    scrollRef.current.scroll({
      top: 0,
    });
  };

  return (
    <div id="Case-List_List" data-testid="Case-List-List">
      {userStats && <CaseListHeader userStats={userStats} />}

      <div className="relative flex h-full max-h-[calc(100vh)] min-h-60 w-full min-w-min flex-row rounded-md bg-white shadow-[3px_3px_10px_0px_rgba(188,209,255)]">
        <div className="flex flex-1 flex-col px-4">
          <div>
            <h2 className="mb-4 mt-6 text-[24px]">Clients</h2>
          </div>
          <div className="mb-4 flex w-full justify-between">
            <div className="flex gap-2">
              <CaseListSearch />
              <CaseListFilter>
                <FiltersList filterState={filterState} />
              </CaseListFilter>
            </div>
            <div>
              <Button
                sx={{
                  color: HNSColors.secondary[500],
                  background: HNSColors.secondary[900],
                  border: `1px solid ${HNSColors.secondary[500]}`,
                  "&:hover": {
                    background: "#FFFFFF",
                  },
                }}
                onClick={() => navigate("/add-client")}
                className="flex items-center gap-2 rounded-full px-8 py-2 text-sm normal-case transition"
                variant="outlined"
                disableElevation
              >
                <Svg name={SvgEnum.HisPlus} />
                Add Client
              </Button>
            </div>
          </div>
          {/* Filter chips */}
          <CaseListChips activeFilters={activeFilters} />

          <div className="flex flex-1 flex-col gap-4 overflow-hidden">
            <div className="flex w-full flex-row items-center justify-between">
              <ItemCounter filters={filters} actualNoOfRows={cases.length} count={count} />
            </div>
            <div className="flex-1 overflow-hidden">
              <CaseTable
                cases={filteredCases}
                filters={filters}
                updateFilter={updateFilter}
                customBaseDetailPath={customBaseDetailPath}
                customBaseDetailSegment={customBaseDetailSegment}
                referenceForScrolling={scrollRef}
                count={count}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
